import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import '../../../assets/scss/datatables.scss';
import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import TechnicianList from './TechniciansList';
import CreateTechnicians from './CreateTechnicians';
import ViewItems from './ViewItems';

const ManageTechnicians = () => {
    const dispatch = useDispatch();
    const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [viewData, setViewData] = useState(null);
    

    const toggleOffcanvas = () => {
        if (isOffcanvasOpen) {
            setEditData(null);
            setViewData(null);
        }
        setOffcanvasOpen(!isOffcanvasOpen);
    };

    const handleEditItem = (item) => {
        setViewData(null);
        setEditData(item);
        setOffcanvasOpen(true);
    };

    const handleViewItem = (item) => {
        setEditData(null);
        setViewData(item);
        setOffcanvasOpen(true);
    };

    const { technicianList = [] } = useSelector((state) => state.service);

    return (
         <>
      <div className="page-content">
        <MetaTags>
          <title>Mange Technicians</title>
        </MetaTags>
        <Container fluid>
             {/* Header Section */}
            <Row>
            <Col xl={4}>
              <DashBreadcrumb title="Service Orders" breadcrumbItem="Manage Technicians" />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center mb-3">
                <div className="DashbordFliter me-2">
                  <button
                    type="button"
                    className="btn btn-dark"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={toggleOffcanvas}
                  >
                    <i className="fa fa-plus me-2"></i>
                    Create Technician
                  </button>
                </div>
                {/* {EXPORT_ALLOWED_USER_ROLES.includes(String(users?.role_id)) && (
                  <div>
                    <ServiceOrderExportReport />
                  </div>
                )} */}
              </div>
            </Col>
          </Row>

          <TechnicianList 
            onEdit={(item) => handleEditItem(item)}
            onView={(item) => handleViewItem(item)}
            technicianList={technicianList}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <CreateTechnicians
            isOpen={isOffcanvasOpen && !viewData} 
            toggle={toggleOffcanvas} 
            editData={editData}
          />
          <ViewItems
            isOpen={isOffcanvasOpen && !!viewData} 
            toggle={toggleOffcanvas} 
            viewData={viewData}
          />
        
        </Container>
        <Toaster position="top-right" reverseOrder={false} containerStyle={{ zIndex: 99999 }} />
        </div>
        </>
    );
};

export default ManageTechnicians;
